import { edmCampaign } from '@bingads-webui/edm-campaign';

export const readSocialSiteRecommendation = (cid, aid, campaignId, finalUrl) => (
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)['Default.GetSocialSitesRecommendation']
    .$makeCall({
      payload: {
        GetSocialSitesRecommendationRequest: {
          FinalURL: finalUrl,
        },
      },
    })
    .toPromise()
);
